import React from 'react';
import styles from './TruncatedText.module.scss';
import clsx from 'clsx';

export const TruncatedText = ({ children, lines = 5, className = '' }) => {
  return (
    <div className={clsx(className, styles.truncated)} style={{ WebkitLineClamp: lines }}>
      {children}
    </div>
  );
};
